// src/hooks/useRole.js
import { useState, useEffect } from "react";
import { logDev } from "../utils/logger.js"

export const useRole = () => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedRole = sessionStorage.getItem("role");
    if (storedRole) {
      logDev("[useRole] rôle trouvé en sessionStorage", { storedRole });
      setRole(storedRole);
  } else {
    logDev("[useRole] aucun rôle trouvé en sessionStorage");
  }
},[]);

  logDev("[useRole] rôle retourné par le hook", { role });
  return role;
};

